import {FieldInput} from "@kroschke/react-ui";
import {FormSection} from "../../../ui";
import {
    VdaDocumentDefaultBaseProps,
    VdaDocumentDefaultFormData,
    VdaDocumentDefaultValidation
} from "./VdaDocumentDefaultForm";
import {ReactNode} from "react";


export interface VdaDocumentCarKeyFormData extends VdaDocumentDefaultFormData{
    note: string | undefined
}


export interface VdaDocumentDefaultFormProps extends VdaDocumentDefaultBaseProps {
    value: VdaDocumentCarKeyFormData
    validation: VdaDocumentDefaultValidation
    onChange: (value: VdaDocumentCarKeyFormData) => any
    onBlur: () => any
    header: ReactNode
}

export function VdaDocumentCarKeyForm({
                                        value,
                                        validation,
                                        disabled,
                                        onChange,
                                        onBlur,
                                        label,
                                        header
                                    }: VdaDocumentDefaultFormProps) {
    return <FormSection
        label={label}
        header={header}
        children={
            <>
                <div className={"columns"}>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={true}
                            value={value.vin}
                            label={"Fahrgestellnummer"}
                        />
                    </div>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={disabled}
                            label={"Dokumenten-Id"}
                            required={true}
                            help={validation.documentId}
                            invalid={Boolean(validation.documentId)}
                            value={value.documentId}
                            onBlur={() => !disabled && onBlur()}
                            onChange={documentID => {
                                onChange({
                                    ...value,
                                    documentId: documentID
                                })
                            }}
                        />
                    </div>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={disabled }
                            label={"Notiz (Kennzeichen)"}
                            value={value.note}
                            onBlur={() => !disabled && onBlur()}
                            inputTransform={e => e.toUpperCase()}
                            onChange={note => {
                                onChange({
                                    ...value,
                                    note: note
                                })
                            }}
                        />
                    </div>
                </div>
                <div className={"columns"}>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={disabled}
                            label={"Position"}
                            required={true}
                            help={validation.position}
                            invalid={Boolean(validation.position)}
                            value={`${value.position}`}
                            onBlur={() => !disabled && onBlur()}
                            onChange={position => {
                                onChange({
                                    ...value,
                                    position: parseInt(position) || 0
                                })
                            }}
                        />
                    </div>
                </div>
            </>
        }
    />
}